import { useDebounce } from 'ahooks'

/** 共用搜索防抖策略；定时器和卸载清理由 ahooks 管理。 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  return useDebounce(value, { wait: delay })
}
